
import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { toArray } from 'ng-zorro-antd/core/util';
import { NzDatePickerComponent } from 'ng-zorro-antd/date-picker';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from 'src/app/Service/api.service';
import { ExportService } from 'src/app/Service/export.service';


@Component({
  selector: 'app-pmsgiantreport',
  templateUrl: './pmsgiantreport.component.html',
  styleUrls: ['./pmsgiantreport.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class PmsgiantreportComponent implements OnInit {
  constructor(public _apiService: ApiService, private notificationService: NzNotificationService, private datePipe: DatePipe, public cookie: CookieService, private _exportService: ExportService) { }

  formTitle = "Daywise Subtask Report";

  ngOnInit(): void {
    this.loadAllProjects(this.str);
    this.loadAllAssignee();
    this.loadAllRoles();
    this.getMonthAndYear();
    this.findTotalDays(this.year, this.month);
  }

  dt = new Date();
  month: number;
  year: number;
  START_DATE: string;
  END_DATE: string;
  radioValue = "E";

  getMonthAndYear() {
    this.month = this.dt.getMonth();
    this.year = this.dt.getFullYear();
  }

  pageIndex = 1;
  pageSize = 10;
  totalRecords = 1;
  sortValue: string = "desc";
  logtext: string = "";
  searchText: string = "";
  columns: string[][] = [["EMPLOYEE_NAME", "Name"]];
  filterQuery: string = "";
  isProjectSpinning = false;
  loadingRecords = false;
  projectData = [];
  projectDataForExcel = [];
  ENQUIRY_DATE = new Date()
  date = new Date();

  getAllProjectWiseHoursDetails(reset: boolean = false) {
    var ok = true;
    if (this.MODULE_ASSIGNEE_ID.length == 0) {
      ok = false
    }

    if (ok) {
      if (reset) {
        this.pageIndex = 1;
      }

      this.loadingRecords = true;
      var sort: string;
      try {
        sort = this.sortValue.startsWith("a") ? "asc" : "desc";

      } catch (error) {
        sort = "";
      }



      if (this.searchText != "") {
        var likeQuery = " AND";
        this.columns.forEach(column => {
          likeQuery += " " + column[0] + " like '%" + this.searchText + "%' OR";
        });
        likeQuery = likeQuery.substring(0, likeQuery.length - 2)

      }

      this.applyFilter();

      var filter = ""
      if (likeQuery)
        filter = this.filterQuery + likeQuery;
      else
        filter = this.filterQuery;



      this._apiService.getallemployeedetailsoftasks1(this.pageIndex, this.pageSize, '', sort, likeQuery).subscribe(data => {
        this.loadingRecords = false;
        this.isProjectSpinning = false;

        this.totalRecords = data['count'];
        this.projectData = data['data'];

      }, err => {

        if (err['ok'] == false)
          this.notificationService.error("Server Not Found", "");
      });

      // Get Data for Excel Sheet
      // this._apiService.getallemployeedetailsoftasks(0, 0, '', sort, this.searchText, this.MODULE_ASSIGNEE_ID.toString(), this.projectID.toString(), this.START_DATE, this.END_DATE).subscribe(data => {
      //   this.projectDataForExcel = data['data'];

      // }, err => {
      //   
      // });
    }
  }
  dta
  getAllProjectWiseHoursDetailss(event) {
    this.dta = this.datePipe.transform(event, "yyyy-MM-dd");
    this._apiService.getallemployeedetailsoftasks1(0, 0, '', '', ' AND DATE= ' + "'" + this.dta + "'").subscribe(data => {
      this.projectData = data['data'];

    }, err => {

    });
  }
  filterClass: string = "filter-invisible";
  isFilterApplied: string = "default";

  PROJECT_DATE = null;
  PROJECT_START_DATE = null;
  PROJECT_END_DATE = null;

  applyFilter() {
    this.getMonthAndYear();
    this.getDaysOfMonth(this.month, this.year);
    this.replaceSpace();

    this.isFilterApplied = "primary";
    this.filterClass = "filter-invisible";


  }


  splitt(varr) {

    if (varr != undefined) {
      // 

      return varr.split(",")
    }
  }

  showFilter(): void {
    if (this.filterClass === "filter-visible")
      this.filterClass = "filter-invisible";
    else
      this.filterClass = "filter-visible";
  }

  clearFilter() {
    this.filterQuery = "";

    this.isFilterApplied = "default";
    this.filterClass = "filter-invisible";

    this.dt = new Date();
    this.date = this.dt;

    this.projectID = [];
    this.TYPE = "";
    this.str = "";

    this.loadAllProjects(this.str);
    this.getMonthAndYear();
    this.findTotalDays(this.year, this.month);
    this.loadAllAssignee();
    this.loadAllRoles();
    this.getAllProjectWiseHoursDetails(true);
    this.radioValue = "E";
  }
  sortKey: string = "id";

  sort(params: NzTableQueryParams): void {
    const { pageSize, pageIndex, sort } = params;
    const currentSort = sort.find(item => item.value !== null);
    const sortField = (currentSort && currentSort.key) || 'id';
    const sortOrder = (currentSort && currentSort.value) || 'asc';
    this.pageIndex = pageIndex;
    this.pageSize = pageSize;

    if (this.pageSize != pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    if (this.sortKey != sortField) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    }

    this.sortKey = sortField;
    this.sortValue = sortOrder;

    if (this.MODULE_ASSIGNEE_ID.length != 0) {
      this.getAllProjectWiseHoursDetails();
    }
  }

  days = new Array();

  getDaysOfMonth(MM, yyyy) {

    this.days = [];

    this.START_DATE = this.datePipe.transform(this.START_DATE, 'yyyy-MM-dd');
    var d = new Date(this.START_DATE).getDate();


    this.END_DATE = this.datePipe.transform(this.END_DATE, 'yyyy-MM-dd');
    var e = new Date(this.END_DATE).getDate();


    for (var i = d; i <= e; i++) {
      var date = new Date(yyyy, MM, i);
      if (date != null) {
        this.days.push(this.datePipe.transform(date, 'yyyy-MM-dd'));
      }
    }
  }

  findTotalDays(yyyy, MM) {
    var numOfDays = new Date(yyyy, MM + 1, 0).getDate();

    var d = new Date(yyyy, MM, 1);
    this.START_DATE = this.datePipe.transform(d, 'yyyy-MM-dd');

    var e = new Date(yyyy, MM, numOfDays);
    this.END_DATE = this.datePipe.transform(e, 'yyyy-MM-dd');

    for (var i = 0; i < numOfDays; i++) {
      var date = new Date(yyyy, MM, i + 1);
      if (date != null) {
        this.days[i] = this.datePipe.transform(date, 'yyyy-MM-dd');
      }
    }
  }

  projectNameKeys = [];
  selectedProjectList = [];

  replaceSpace() {
    this._apiService.getAllProjects(0, 0, 'START_DATE', 'desc', ' and ID in (' + this.projectID + ')').subscribe(projectData => {
      if (projectData['code'] == 200) {
        this.projectNameKeys = [];
        this.selectedProjectList = [];

        this.selectedProjectList = projectData['data'];


        for (var i = 0; i < this.selectedProjectList.length; i++) {
          var a = [];
          // a[0] = (this.projectList[i]['NAME'].replaceAll(' ', '_'));

          a[0] = (this.selectedProjectList[i]['ABBREVATION']);
          a[1] = (this.selectedProjectList[i]['ABBREVATION']);
          a[2] = (this.selectedProjectList[i]['NAME']);

          this.projectNameKeys.push(a);
        }


      }

    }, err => {

    });
  }

  onEnterGetAllProjectWiseHoursDetails() {
    document.getElementById("button1").focus();
    this.getAllProjectWiseHoursDetails(true);
  }

  importInExcel() {
    var arry1 = [];
    var arry2 = [];
    var arry3 = [];

    var obj1: any = new Object();
    var obj2: any = new Object();
    var obj3: any = new Object();

    for (var i = 0; i < this.projectDataForExcel.length; i++) {
      obj1['Name'] = this.projectDataForExcel[i]['NAME'];
      obj2['Name'] = this.projectDataForExcel[i]['NAME'];
      obj3['Name'] = this.projectDataForExcel[i]['NAME'];

      obj1['Total Time'] = this._apiService.convertIntoHMS(Number(this.projectDataForExcel[i]['TOTAL_SECONDS']));
      obj2['Total Seconds'] = this.projectDataForExcel[i]['TOTAL_SECONDS'];
      obj3['Total'] = parseFloat(String(Number(this.projectDataForExcel[i]['TOTAL_SECONDS']) / 3600)).toFixed(2);

      for (var j = 0; j < this.selectedProjectList.length; j++) {
        obj1[this.selectedProjectList[j]['NAME']] = this._apiService.convertIntoHMS(Number(this.projectDataForExcel[i][this.selectedProjectList[j]['ABBREVATION']]));
        obj2[this.selectedProjectList[j]['NAME']] = this.projectDataForExcel[i][this.selectedProjectList[j]['ABBREVATION']];
        obj3[this.selectedProjectList[j]['NAME']] = parseFloat(String(Number(this.projectDataForExcel[i][this.selectedProjectList[j]['ABBREVATION']]) / 3600)).toFixed(2);

        if (j == this.selectedProjectList.length - 1) {
          arry1.push(Object.assign({}, obj1));
          arry2.push(Object.assign({}, obj2));
          arry3.push(Object.assign({}, obj3));
        }
      }

      if (i == this.projectDataForExcel.length - 1) {
        this._exportService.exportExcel(arry1, 'Employee Project Wise (HH:MM:SS)');
        this._exportService.exportExcel(arry2, 'Employee Project Wise (In Seconds)');
        this._exportService.exportExcel(arry3, 'Employee Project Wise');
      }
    }
  }

  // Getting Users
  assigneeList = [];
  categoryID = 0;

  loadAllAssignee() {
    this.assigneeList = [];
    var USER_ID = this._apiService.userId;

    this._apiService.getAllUsers(0, 0, 'ID', 'desc', '').subscribe(userData => {
      if (userData['code'] == 200) {


        this.assigneeList = userData['data'];

        this.loadAllRoles();
      }

    }, err => {

    });

    // Current User Category
    this._apiService.getAllUsers(0, 0, 'ID', 'desc', ' and ID=' + this._apiService.userId).subscribe(userData => {
      if (userData['code'] == 200) {

        this.categoryID = userData['data'][0]['TASK_CATEGORY_ID'];
      }

    }, err => {

    });
  }

  roleData = [];

  loadAllRoles() {
    this.roleData = [];

    var level = this.cookie.get("level");
    var nextLevel = Number(this.cookie.get("level")) + 1;

    // level = level + ',' + nextLevel;

    if (this.cookie.get("level") == "1" || this.cookie.get("level") == "2") {
      this._apiService.getAllRoles(0, 0, 'ID', 'desc', '').subscribe(data => {
        if (data['code'] == 200) {


          this.roleData = data['data'];

          this.findNewAssigneeList();


          if (this.MODULE_ASSIGNEE_ID.length != 0) {
            this.getAllProjectWiseHoursDetails(true);
          }
        }

      }, err => {

      });

    } else {
      this._apiService.getAllRoles(0, 0, 'ID', 'desc', ' and LEVEL >= (' + level + ')').subscribe(data => {
        if (data['code'] == 200) {


          this.roleData = data['data'];

          this.findNewAssigneeList();


          if (this.MODULE_ASSIGNEE_ID.length != 0) {
            this.getAllProjectWiseHoursDetails(true);
          }
        }

      }, err => {

      });
    }
  }

  newAssigneeList = [];
  MODULE_ASSIGNEE_ID = [];
  TYPE = "";

  findNewAssigneeList() {
    this.newAssigneeList = [];
    this.MODULE_ASSIGNEE_ID = [];

    for (var j = 0; j < this.roleData.length; j++) {
      for (var k = 0; k < this.assigneeList.length; k++) {
        if (Number(this.assigneeList[k]['ROLE_IDS']) == this.roleData[j]['ID']) {
          if (this.cookie.get("level") == "1" || this.cookie.get("level") == "2" || this.cookie.get("level") == "3") {
            this.newAssigneeList.push(this.assigneeList[k]);

          } else if (this.cookie.get("level") == "4") {
            if (Number(this.assigneeList[k]['TASK_CATEGORY_ID']) == this.categoryID) {
              this.newAssigneeList.push(this.assigneeList[k]);
            }

          } else {
            if (Number(this.assigneeList[k]['ID']) == this._apiService.userId) {
              this.newAssigneeList.push(this.assigneeList[k]);
            }
          }
        }
      }
    }




    for (var i = 0; i < this.newAssigneeList.length; i++) {
      this.MODULE_ASSIGNEE_ID.push(this.newAssigneeList[i]['ID']);
    }
  }

  projectID = [];
  projectList = [];

  loadAllProjects(str) {
    this.projectID = [];

    this._apiService.getAllProjects(0, 0, 'START_DATE', 'desc', str).subscribe(projectData => {
      if (projectData['code'] == 200) {
        this.projectList = projectData['data'];


        for (var i = 0; i < this.projectList.length; i++) {
          this.projectID.push(this.projectList[i]['ID']);
        }
      }

    }, err => {

    });
  }

  str = "";

  onStatusChange(type) {

    this.projectID = [];

    if (type == "B") {
      this.str = ' and IS_ACTIVE=1 and IS_BILLABLE=1';

    } else if (type == "NB") {
      this.str = ' and IS_ACTIVE=1 and IS_BILLABLE=0';

    } else if (type == null) {
      this.str = ' and IS_ACTIVE=1 and IS_BILLABLE in (0,1)';
    }

    this.loadAllProjects(this.str);
  }

  @ViewChild('endDatePicker') endDatePicker: NzDatePickerComponent;

  startDateHandle(open: boolean) {
    this.END_DATE = null;

    if (!open) {
      this.endDatePicker.open();
      this.END_DATE = this.START_DATE;
    }
  }

  disabledEndDate = (endValue: Date): boolean => {
    if (this.START_DATE != null) {
      if (!endValue) {
        return false;
      }

      var previousDate = new Date(this.START_DATE);
      previousDate.setDate(previousDate.getDate() + (-1));

      return endValue <= new Date(previousDate);
    };
  }

  changeRadioButton(radioButtonValue, apply = false) {
    if (radioButtonValue == "A") {
      let currentDate = new Date();
      this.START_DATE = this.datePipe.transform(currentDate, 'yyyy-MM-dd');
      this.END_DATE = this.datePipe.transform(currentDate, 'yyyy-MM-dd');

    } else if (radioButtonValue == "B") {
      let currentDate = new Date();
      let previousDate = currentDate.setDate(currentDate.getDate() + (-1));

      this.START_DATE = this.datePipe.transform(previousDate, 'yyyy-MM-dd');
      this.END_DATE = this.datePipe.transform(previousDate, 'yyyy-MM-dd');

    } else if (radioButtonValue == "C") {
      let currentDate = new Date();
      let previous6thDayDate = currentDate.setDate(currentDate.getDate() + (-6));
      let next7thDayDate = currentDate.setDate(currentDate.getDate() + (6));

      this.START_DATE = this.datePipe.transform(previous6thDayDate, 'yyyy-MM-dd');
      this.END_DATE = this.datePipe.transform(next7thDayDate, 'yyyy-MM-dd');

    } else if (radioButtonValue == "D") {
      let currentDate = new Date();
      let lastMonth = currentDate.getMonth() + (-1);
      let currentYear = currentDate.getFullYear();
      let numOfDays = new Date(currentYear, lastMonth + 1, 0).getDate();

      let d = new Date(currentYear, lastMonth, 1);
      this.START_DATE = this.datePipe.transform(d, 'yyyy-MM-dd');

      let e = new Date(currentYear, lastMonth, numOfDays);
      this.END_DATE = this.datePipe.transform(e, 'yyyy-MM-dd');

    } else if (radioButtonValue == "E") {
      let currentDate = new Date();
      let currentMonth = currentDate.getMonth();
      let currentYear = currentDate.getFullYear();
      let numOfDays = new Date(currentYear, currentMonth + 1, 0).getDate();

      let d = new Date(currentYear, currentMonth, 1);
      this.START_DATE = this.datePipe.transform(d, 'yyyy-MM-dd');

      let e = new Date(currentYear, currentMonth, numOfDays);
      this.END_DATE = this.datePipe.transform(e, 'yyyy-MM-dd');
    }

    if (apply) {
      this.applyWithRadioButtons();
    }
  }

  applyWithRadioButtons() {
    this.loadingRecords = true;
    this.pageIndex = 1;

    this._apiService.getallemployeedetailsoftasks(this.pageIndex, this.pageSize, '', 'asc', this.searchText, this.MODULE_ASSIGNEE_ID.toString(), this.projectID.toString(), this.START_DATE, this.END_DATE).subscribe(data => {
      this.loadingRecords = false;

      this.totalRecords = data['count'];
      this.projectData = data['data'];

    }, err => {

      if (err['ok'] == false)
        this.notificationService.error("Server Not Found", "");
    });

    // Get Data for Excel Sheet
    this._apiService.getallemployeedetailsoftasks(0, 0, '', 'asc', this.searchText, this.MODULE_ASSIGNEE_ID.toString(), this.projectID.toString(), this.START_DATE, this.END_DATE).subscribe(data => {
      this.projectDataForExcel = data['data'];

    }, err => {

    });
  }
}
